<template>
  <!-- Create / Edit -->
  <v-dialog v-model="dialog" width="1360" persistent fullscreen>
    <v-toolbar>
      <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
        <v-row no-gutters>
          <v-col cols="12" md="4">
            <!-- ========================================= -->
            <!--               Subordination               -->
            <!-- ========================================= -->
            <v-subheader class="overline pt-4"
              >{{ $t("subordination") }}
            </v-subheader>
            <div class="pa-4 px-6">
              <v-autocomplete
                v-model="form.subordination.select"
                :items="form.subordination.items"
                :rules="selectRules"
                item-text="name_local"
                item-value="id_local"
                :label="$t('mLocal')"
                outlined
                dense
                return-object
                required
              ></v-autocomplete>
            </div>

            <!-- ========================================= -->
            <!--             Registration form             -->
            <!-- ========================================= -->
            <v-subheader class="overline pt-4"
              >{{ $t("registrationForm") }}
            </v-subheader>
            <div class="pa-4 px-6">
              <v-text-field
                :label="$t('fullName')"
                v-model="form.fullName"
                :rules="fullNameRules"
                required
                clearable
                outlined
                dense
                autofocus
              ></v-text-field>

              <v-text-field
                label="CPF"
                v-model="form.doc"
                required
                clearable
                outlined
                dense
                v-mask="maskDoc"
                :rules="requiredRules"
              ></v-text-field>
              <v-text-field
                label="E-mail"
                v-model="form.email"
                :rules="emailRules"
                outlined
                dense
                name="newEmailUser"
              ></v-text-field>
              <v-row>
                <div class="col-12 col-md-6 py-0">
                  <v-text-field
                    :label="$t('mobile1')"
                    v-model="form.phone1"
                    required
                    clearable
                    outlined
                    dense
                    v-mask="maskPhone"
                    :rules="requiredRules"
                  ></v-text-field>
                </div>
                <div class="col-12 col-md-6 py-0">
                  <v-text-field
                    :label="$t('mobile2')"
                    v-model="form.phone2"
                    clearable
                    outlined
                    dense
                    v-mask="maskPhone"
                  ></v-text-field>
                </div>
              </v-row>
              <v-row>
                <div class="col-12 col-md-4 py-0">
                  <v-text-field
                    label="Cep"
                    v-model="form.zipCode"
                    :loading="loadingZipCode"
                    :disabled="disabled"
                    required
                    outlined
                    dense
                    v-mask="'#####-###'"
                    append-icon="mdi-magnify"
                    @click:append="consultZipCode(form.zipCode)"
                    @blur="consultZipCode(form.zipCode)"
                  ></v-text-field>
                </div>
                <div class="col-12 col-md-8 py-0">
                  <v-text-field
                    :label="$t('address')"
                    v-model="form.address"
                    :disabled="disabled"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-row>
              <v-row>
                <div class="col-12 col-md-6 py-0 pb-0">
                  <v-select
                    v-model="form.state.select"
                    :items="form.state.items"
                    item-text="nome"
                    item-value="id"
                    :label="$t('state')"
                    :disabled="disabled"
                    outlined
                    dense
                    return-object
                    persistent-hint
                    :loading="loadingState"
                    @change="getCitys(form.state.select.id)"
                    required
                    class="mb-2"
                    :hint="$t('toSaveStateMsg')"
                  ></v-select>
                </div>

                <div class="col-12 col-md-6 py-0">
                  <v-select
                    v-model="form.city.select"
                    :items="form.city.items"
                    item-text="nome"
                    item-value="id"
                    :label="$t('city')"
                    :disabled="disabled"
                    outlined
                    dense
                    return-object
                    required
                    class="mb-0"
                  ></v-select>
                </div>
              </v-row>
              <v-textarea
                v-model="form.informacoes"
                :label="$t('remarks')"
                outlined
                height="106"
              ></v-textarea>
            </div>
          </v-col>

          <v-col cols="12" md="4">
            <!-- ========================================= -->
            <!--                  Limits                   -->
            <!-- ========================================= -->
            <v-subheader class="overline pt-4">{{ $t("limits") }} </v-subheader>
            <div class="pa-4 px-6">
              <v-progress-circular
                v-if="limitsProgress"
                indeterminate
              ></v-progress-circular>
              <template>
                <v-text-field
                  v-model="form.partida"
                  :label="$t('valuePerMatch')"
                  :prefix="currencyLabel"
                  outlined
                  dense
                  :rules="requiredRules"
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-model="form.limitDayBet"
                  :label="$t('dailyBettingLimit')"
                  :prefix="currencyLabel"
                  outlined
                  dense
                  :rules="requiredRules"
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-model="form.limitDayBetSingle"
                  :label="$t('dailyLimitSingleBets')"
                  :prefix="currencyLabel"
                  outlined
                  dense
                  :rules="requiredRules"
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-model="form.limitDayBetDouble"
                  :label="$t('dailyLimitDoubleBets')"
                  :prefix="currencyLabel"
                  outlined
                  dense
                  :rules="requiredRules"
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-model="form.teto"
                  :label="$t('maximumAgentAward')"
                  :prefix="currencyLabel"
                  outlined
                  dense
                  :rules="requiredRules"
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-if="retail == 2"
                  v-model="form.vendas"
                  :label="$t('creditSaleLimit')"
                  :prefix="currencyLabel"
                  outlined
                  dense
                  :rules="requiredRules"
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-model="form.fator_confiabilidade"
                  min="0"
                  max="1"
                  step="0.01"
                  :label="$t('realiabilityFactor')"
                  outlined
                  dense
                  type="number"
                ></v-text-field>
              </template>
            </div>
            <div v-if="retail == 1">
              <v-subheader class="overline pt-4">
                {{ $t("prizePercentage") }}
              </v-subheader>
              <div class="pa-4 px-6">
                <v-text-field
                  v-model="form.porcentagem_premio"
                  :label="$t('prizePercentage')"
                  :rules="prizePercentageRules"
                  min="0"
                  max="100"
                  step="1"
                  prefix="%"
                  outlined
                  dense
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-model="form.eventos_premio"
                  :label="$t('eventNumberNeededForAgentPrizePercentage')"
                  :rules="eventPrizeRules"
                  class="mt-1"
                  min="0"
                  max="100"
                  step="1"
                  outlined
                  dense
                  type="number"
                ></v-text-field>
              </div>
            </div>
            <v-subheader class="overline pt-4">{{
              retail == 1 ? $t("agentBalance") : $t("generalSalesLimit")
            }}</v-subheader>
            <div class="pa-4 px-6">
              <v-text-field
                v-model="form.limit_retention"
                :label="
                  retail == 1 ? $t('agentBalance') : $t('generalSalesLimit')
                "
                :prefix="currencyLabel"
                outlined
                dense
                :rules="retail == 1 ? [] : requiredRules"
                type="number"
                :disabled="showAgentBalanceIncrement && retail == 1"
              ></v-text-field>

              <div v-if="retail == 1 && showAgentBalanceIncrement">
                <v-btn @click="showEditBalance = !showEditBalance" class="mb-3">
                  {{ $t("editAgentBalance") }}
                </v-btn>
                <div v-if="showEditBalance">
                  <v-text-field
                    v-model="form.limit_retention_increment"
                    :label="$t('incrementAgentBalance')"
                    :prefix="currencyLabel"
                    outlined
                    dense
                    type="number"
                  ></v-text-field>
                  <div v-if="retail == 1" class="d-flex justify-space-around">
                    <v-btn
                      class="mb-3"
                      :loading="loadingLimitRetentionAdd"
                      v-on:click.prevent="addLimitRetention"
                      >{{ $t("add") }}
                    </v-btn>
                    <v-btn
                      class="mb-3"
                      :loading="loadingLimitRetentionReset"
                      v-on:click.prevent="resetLimitRetention"
                      >{{ $t("reset") }}
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="4">
            <!-- ========================================= -->
            <!--              Configurations               -->
            <!-- ========================================= -->
            <v-subheader class="overline pt-4"
              >{{ $t("settings") }}
            </v-subheader>
            <div class="pa-4 px-6">
              <v-select
                v-model="form.occupationArea.select"
                :items="form.occupationArea.items"
                item-text="name"
                item-value="id"
                :label="$t('areaOfExpertise')"
                outlined
                return-object
                :rules="selectRules"
                required
                dense
              ></v-select>
              <v-select
                v-model="form.activeLive.select"
                :items="form.activeLive.items"
                item-text="name"
                item-value="id"
                :label="$t('activateLive')"
                outlined
                dense
                return-object
                :rules="selectRules"
                required
              ></v-select>
              <v-select
                v-model="form.awards.select"
                :items="form.awards.items"
                item-text="name"
                item-value="id"
                :label="$t('vieAwardees')"
                outlined
                dense
                return-object
                :rules="selectRules"
                required
              ></v-select>
              <v-select
                v-model="form.status.select"
                :items="form.status.items"
                item-text="name"
                item-value="id"
                :label="$t('status')"
                outlined
                dense
                return-object
                :rules="selectRules"
                required
              ></v-select>
              <v-select
                v-if="retail == 2"
                v-model="form.autoPremio.select"
                :items="form.autoPremio.items"
                item-text="name"
                item-value="id"
                :label="$t('automaticPayment')"
                outlined
                dense
                return-object
                :rules="selectRules"
                required
              ></v-select>
              <v-text-field
                :label="$t('marginOfQuotation')"
                v-model="form.margin_odds"
                :rules="requiredRules"
                required
                clearable
                outlined
                type="number"
                dense
              ></v-text-field>
              <v-text-field
                v-if="retail == 2"
                :label="$t('commissionsOnCreditSales')"
                v-model="form.comission_sales_credit"
                :rules="requiredComission"
                required
                clearable
                outlined
                type="number"
                dense
              ></v-text-field>
              <v-text-field
                :label="$t('maximumMutiplier')"
                v-model="form.multi_max"
                :rules="requiredRules"
                required
                clearable
                outlined
                type="number"
                dense
              ></v-text-field>
              <v-text-field
                :label="$t('minimumMultiplier')"
                v-model="form.multi_min"
                :rules="requiredRules"
                required
                clearable
                outlined
                type="number"
                dense
              ></v-text-field>
            </div>

            <!-- ========================================= -->
            <!--                CredentialS                -->
            <!-- ========================================= -->
            <v-subheader class="overline pt-4"
              >{{ $t("accessCredential") }}
            </v-subheader>
            <div class="pa-4 px-6">
              <v-text-field
                :label="$t('login')"
                v-model="form.login"
                :rules="usernameRules"
                required
                clearable
                outlined
                dense
                autocapitalize="off"
              ></v-text-field>
              <template v-if="edit">
                <v-btn @click="editPassword = !editPassword" class="mb-3">
                  {{ $t("changePassword") }}
                </v-btn>
              </template>
              <template v-if="editPassword || !edit">
                <v-text-field
                  :class="[
                    !form.password || show ? 'show-password' : 'hide-password',
                  ]"
                  :label="$t('password')"
                  v-model="form.password"
                  :rules="passwordRules"
                  required
                  clearable
                  outlined
                  dense
                  name="newPasswordUser"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show = !show"
                  type="text"
                  :counter="8"
                  maxlength="8"
                  autocapitalize="off"
                ></v-text-field>
                <v-text-field
                  :class="[
                    !form.confirmPassword || show1
                      ? 'show-password'
                      : 'hide-password',
                  ]"
                  :label="$t('confirmPassword')"
                  v-model="form.confirmPassword"
                  :rules="passMatch"
                  required
                  clearable
                  outlined
                  dense
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show1 = !show1"
                  type="text"
                  :counter="8"
                  maxlength="8"
                  autocapitalize="off"
                ></v-text-field>
              </template>
            </div>
          </v-col>
        </v-row>

        <!-- ========================================= -->
        <!--                 Actions                   -->
        <!-- ========================================= -->
        <v-divider></v-divider>

        <v-alert
          class="ma-4"
          type="warning"
          v-for="item in handleError.items"
          :key="item"
        >
          {{ item }}
        </v-alert>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="info"
            :loading="loading"
            v-on:click.prevent="updateAgent"
            type="submit"
            :disabled="!valid"
            >{{ $t("toSave") }}</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import { validate } from "@/util/validate";
export default {
  name: "local-manager-user-update",
  data: () => ({
    showEditBalance: false,
    showAgentBalanceIncrement: false,
    loadingLimitRetentionReset: false,
    loadingLimitRetentionAdd: false,
    retail: false,
    edit: false,
    valid: false,
    loading: false,
    disabled: false,
    loadingZipCode: false,
    loadingState: false,
    show: false,
    show1: false,
    limitsProgress: true,
    editPassword: false,
    maskDoc: "###.###.###-##",
    maskPhone: "(##) #####-####",
    handleError: {
      items: [],
    },
    form: {
      // Sector: Subordination
      subordination: {
        select: [],
        items: [],
      },
      // Sector: Registration form
      fullName: "",
      doc: "",
      phone1: "",
      phone2: "",
      email: "",
      zipCode: "",
      address: "",
      state: {
        select: [],
        items: [],
      },
      city: {
        select: [],
        items: [],
      },
      //  Sector: Limits
      limitDayBet: undefined,
      limitDayBetSingle: undefined,
      limitDayBetDouble: undefined,
      partida: undefined,
      teto: undefined,
      vendas: undefined,
      limit_retention: undefined,
      limit_retention_increment: undefined,
      fator_confiabilidade: undefined,
      informacoes: "",
      //  Sector: Configurations
      margin_odds: "0",
      comission_sales_credit: "0",
      multi_max: "0",
      multi_min: "0",
      occupationArea: {
        select: [],
        items: [],
      },
      activeLive: {
        select: { id: 1, name: "Sim" },
        items: [
          { id: 1, name: "Sim" },
          { id: 0, name: "Não" },
        ],
      },
      status: {
        select: { id: 1, name: "Ativo" },
        items: [
          { id: 1, name: "Ativo" },
          { id: 0, name: "Bloqueado" },
        ],
      },
      autoPremio: {
        select: { id: 0, name: "Não" },
        items: [
          { id: 1, name: "Sim" },
          { id: 0, name: "Não" },
        ],
      },
      awards: {
        select: { id: 0, name: "Não" },
        items: [
          { id: 1, name: "Sim" },
          { id: 0, name: "Não" },
        ],
      },
      // Sector: CredentialS
      login: "",
      password: "",
      confirmPassword: "",

      // Porcentagem do prêmio destinado ao agente
      porcentagem_premio: '',
      eventos_premio: '',
    },

    // Transforma type password em type text
    fieldTypes: {
      password: "text",
    },

    //
    // Validate Forms:
    fullNameRules: [validate.required, validate.max],
    docRules: [validate.required],
    emailRules: [validate.validEmail],
    phone1Rules: [validate.phoneCounter],
    phone2Rules: [validate.phoneCounter2],
    selectRules: [validate.selectRequired],
    requiredRules: [validate.required, validate.max],
    requiredComission: [validate.required, validate.negativeNo],
    usernameRules: [
      validate.required,
      validate.usernameMax,
      validate.username,
      validate.max,
    ],
    passwordRules: [
      validate.required,
      validate.passRule,
      validate.passCaracter,
      validate.max,
    ],

    docCounter: {
      max: "Max" | 14,
    },
    required: validate.required,
    // Edit
    id_agent: "",

    prizePercentageRules: [validate.negativeNo, validate.max100],
    eventPrizeRules: [validate.negativeNo],
  }),

  async created() {
    // =================================================== //
    // Translate
    // =================================================== //
    this.form.activeLive = {
      select: { id: 1, name: this.$t("yes") },
      items: [
        { id: 1, name: this.$t("yes") },
        { id: 0, name: this.$t("no") },
      ],
    };
    this.form.status = {
      select: { id: 1, name: this.$t("active") },
      items: [
        { id: 1, name: this.$t("active") },
        { id: 0, name: this.$t("blocked") },
      ],
    };
    this.form.autoPremio = {
      select: { id: 0, name: this.$t("no") },
      items: [
        { id: 1, name: this.$t("yes") },
        { id: 0, name: this.$t("no") },
      ],
    };
    this.form.awards = {
      select: { id: 0, name: this.$t("no") },
      items: [
        { id: 1, name: this.$t("yes") },
        { id: 0, name: this.$t("no") },
      ],
    };

    // =================================================== //
    // Add
    // =================================================== //
    // Retrieve Local Managers
    // Retrieve States
    let localManagersResponse = this.$request.post(
      "administrator/locals/list",
      { status: 1 }
    );
    let occupationAreaResponse = this.$request.get("administrator/areas/list");
    let statesResponse = this.$axios.get("player/register/fetchStates");
    // Request's Simultaneously
    let localManagers = await localManagersResponse;
    let occupationArea = await occupationAreaResponse;
    let states = await statesResponse;
    this.limitsProgress = false;
    // Set Responses:
    this.form.subordination.items = localManagers.dados;
    this.form.occupationArea.items = occupationArea.dados;
    this.form.state.items = states.data.dados;
    // Retrieves Defaults:
    this.form.teto = this.$operator.max_prize;
    this.form.multi_max = this.$operator.multi_max;
    this.form.multi_min = this.$operator.multi_min;
    // =================================================== //
    // IF - Edit
    // =================================================== //
    if (!this.$route.params.id) {
      return;
    }
    this.edit = true;
    let id_user = this.$route.params.id;
    let data = await this.$request.post("/administrator/agents/getAgent", {
      id_user,
    });
    const {
      endereco,
      documento,
      email,
      id,
      id_local,
      login,
      nome,
      celular,
      visualizar_ao_vivo,
      status,
      auto_premio,
      telefone,
      multiplicador_maximo,
      multiplicador_minimo,
      id_area,
      comissao_creditos,
      margem,
      area,
      limite_retençao,
      total_diario,
      total_diario_duplas,
      total_diario_simples,
      limite_partida,
      info,
      premio_maximo,
      limite_vendas,
      cep,
      visualizar_premiada,
      fator_confiabilidade,
      porcentagem_premio,
      eventos_premio,
    } = data.dados;
    // Registration form
    this.form.fullName = nome;
    this.form.doc = documento;
    this.form.email = email;
    this.form.phone1 = telefone;
    this.form.phone2 = celular;
    this.form.zipCode = cep;
    this.form.address = endereco;
    this.consultZipCode(cep);
    this.form.informacoes = info;
    //  Sector: Configurations
    this.form.margin_odds = margem;
    this.form.comission_sales_credit = comissao_creditos;
    this.form.multi_max = multiplicador_maximo;
    this.form.multi_min = multiplicador_minimo;
    this.form.porcentagem_premio =
      !porcentagem_premio || porcentagem_premio == "0.00"
        ? 0
        : porcentagem_premio;
    this.form.eventos_premio =
      !eventos_premio || eventos_premio === 0 ? 0 : eventos_premio;
    this.form.occupationArea.select = {
      id: id_area,
      name: area,
    };
    this.form.activeLive.select = {
      id: Number(visualizar_ao_vivo),
      name: visualizar_ao_vivo == "0" ? this.$t("no") : this.$t("yes"),
    };
    this.form.awards.select = {
      id: Number(visualizar_premiada),
      name: visualizar_premiada == "0" ? this.$t("no") : this.$t("yes"),
    };
    this.form.status.select = {
      id: Number(status),
      name: status == "0" ? this.$t("blocked") : this.$t("active"),
    };
    this.form.autoPremio.select = {
      id: Number(auto_premio),
      name: auto_premio == "0" ? this.$t("no") : this.$t("yes"),
    };
    // Limits
    this.form.limitDayBet = total_diario;
    this.form.limitDayBetSingle = total_diario_simples;
    this.form.limitDayBetDouble = total_diario_duplas;
    this.form.limit_retention = limite_retençao;
    this.form.partida = limite_partida;
    this.form.teto = premio_maximo;
    this.form.vendas = limite_vendas;
    this.form.fator_confiabilidade = fator_confiabilidade;
    // Login
    this.form.login = login;
    // Edit
    this.id_agent = id;
    // Handle Local Manager - Subordination:
    var select = this.form.subordination.items.filter((item) => {
      return item.id_local == id_local;
    });
    this.form.subordination.select = select[0];
  },
  mounted() {
    this.retail = localStorage.getItem("operator-retail");
    const isEditAgentRoute = this.$route.name == "AdministratorUsersAgentsEdit";

    if (isEditAgentRoute) {
      this.showAgentBalanceIncrement = true;
    }
  },
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
    // // Repet password
    passMatch() {
      const rules = [];
      let required = this.$t("requiredInput");
      let repeatPassWord = this.$t("repeatThePassword");
      // Required
      if (this.form.confirmPassword) {
        const rule = (v) => !!v || required;
        rules.push(rule);
      }

      // Confirm Password
      if (this.form.password) {
        const rule = (v) => (!!v && v) === this.form.password || repeatPassWord;
        rules.push(rule);
      }

      return rules;
    },
    currencyLabel() {
      return this.$t("labelCurrency");
    },
  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    async addLimitRetention() {
      this.loadingLimitRetentionAdd = true;

      const value = this.form.limit_retention_increment;

      const body = { id_user: this.$route.params.id, value };

      try {
        const response = await this.$request.post(
          "/administrator/retail/agents/addAgentCredit",
          body
        );
        this.form.limit_retention = response.dados.credito_atual;
        this.$store.commit("setFeedbackSnack", {
          msg: response.messages,
          color: "success",
        });
      } catch (e) {
        console.error(e);
      }

      this.loadingLimitRetentionAdd = false;
    },
    async resetLimitRetention() {
      this.loadingLimitRetentionReset = true;

      try {
        const response = await this.$request.post(
          "/administrator/retail/agents/resetAgentCredit",
          { id_user: this.$route.params.id }
        );
        this.form.limit_retention = 0;
        this.$store.commit("setFeedbackSnack", {
          msg: response.messages,
          color: "success",
        });
      } catch (e) {
        console.error(e);
      }

      this.loadingLimitRetentionReset = false;
    },

    //
    //
    // Consult CEP (ZipCode)
    async consultZipCode(zipCode) {
      if (!zipCode) return;
      const body = {
        cep: zipCode.replace(/[^0-9]+/g, ""),
      };
      // handle fields
      this.disabled = true;
      this.loadingZipCode = true;
      try {
        // 1. Resques CEP/ZipCode
        const response = await this.$request.post(
          "player/register/fetchCep",
          body
        );
        // 2. Handle Address:
        this.form.address = response.dados.logradouro;
        // 3. Handle Select-State:
        const uf = response.dados.uf;
        const state = this.form.state.items.filter((item) => item.uf == uf);
        this.form.state.select = state[0];
        this.getCitys(state[0].id, response.dados.cidade);
      } catch (error) {
        console.log(error);
      } finally {
        // handle fields end.
        this.loadingZipCode = false;
        this.disabled = false;
      }
    },
    //
    //
    // getCitys
    async getCitys(stateId, nameCity) {
      this.loadingState = true;
      this.disabled = true;
      try {
        const citys = await this.$request.post("player/register/fetchCities", {
          id_state: stateId,
        });
        this.form.city.items = citys.dados;

        if (!nameCity) {
          return;
        }
        const city = this.form.city.items.filter(
          (item) => item.nome == nameCity.toUpperCase()
        );
        this.form.city.select = city[0];
        // Tratamento para o BUG da API de CEP quando envia o CEP 00000-000 ele retorna esses valores abaixo
        // Como não existe essa cidade a requisição não estava certa então foi criada essa condicional
        if (this.form.address == "LOGRADOURO" && nameCity == "CIDADE") {
          this.form.city.items.push({
            id: "00000",
            nome: "CIDADE NÃO ENCONTRADA",
          });
          const city = this.form.city.items.filter(
            (item) => item.nome == "CIDADE NÃO ENCONTRADA"
          );
          this.form.city.select = city[0];
          this.form.address = "RUA NÃO ENCONTRADA";
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.disabled = false;
        this.loadingState = false;
      }
    },
    //
    //
    // updateAgent: Create or Edit Agent.
    async updateAgent() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (this.form.phone1.length != 15) {
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("phoneMustCointais11Digits"),
          color: "red",
        });
        return;
      }
      if (this.form.doc.length != 14) {
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("CPFMustCointais11Digits"),
          color: "red",
        });
        return;
      }

      // Global progress
      this.$store.commit("setFeedbackProgress", true);
      this.loading = true;
      // Body Request Verify Login
      const verifyLogin = {
        domain: this.$localStorage.getItem("user_data").db_name,
        login: this.form.login,
      };
      // Body Request Create Agent
      const formUpdateAgent = {
        nome: this.form.fullName,
        login: this.form.login,
        password: this.form.password,
        status: this.form.status.select.id,
        auto_premio: this.form.autoPremio.select.id,
        id_gerente: this.form.subordination.select.id_local,
        email: this.form.email,
        cpf: this.form.doc.replace(/[^0-9]+/g, ""),
        endereco: this.form.address,
        municipio: this.form.city.select.id,
        estado: this.form.state.select.id,
        telefone: this.form.phone2
          ? this.form.phone2.replace(/[^0-9]+/g, "")
          : "",
        celular: this.form.phone1.replace(/[^0-9]+/g, ""),
        cep: this.form.zipCode.replace(/[^0-9]+/g, ""),
        limite_diario: this.form.limitDayBet,
        limite_simples: this.form.limitDayBetSingle,
        limite_duplas: this.form.limitDayBetDouble,
        partida: this.form.partida,
        teto: this.form.teto,
        vendas: this.form.vendas,
        informacoes: this.form.informacoes,
        live: this.form.activeLive.select.id,
        limit_retention: this.form.limit_retention,
        premiadas: this.form.awards.select.id,
        id_area: this.form.occupationArea.select.id,
        margin_odds: this.form.margin_odds,
        comission_sales_credit: this.form.comission_sales_credit,
        multi_max: this.form.multi_max,
        multi_min: this.form.multi_min,
        fator_confiabilidade: this.form.fator_confiabilidade,
        porcentagem_premio: this.form.porcentagem_premio,
        eventos_premio: this.form.eventos_premio,
      };
      // Submit Form
      try {
        if (this.edit) {
          Object.assign(formUpdateAgent, { id_user: this.id_agent });
        } else {
          // Add Agent - Verify existing login
          const verify = await this.$request.post(
            "main/fetchLogin",
            verifyLogin
          );
          if (verify.length == 0) {
            return;
          }
        }
        const updateEndpoint = this.edit
          ? "administrator/agents/editAgent"
          : "administrator/agents/addAgent";
        const result = await this.$request.post(
          updateEndpoint,
          formUpdateAgent
        );
        if (result.length == 0) {
          return;
        }
        this.$store.commit("setFeedbackSnack", {
          msg: result.messages,
          color: "success",
        });
        if (!this.edit) {
          this.$refs.form.reset();
        }
        this.$store.commit("showDialog", false);
        this.$store.commit("setRefresh", true);
      } catch (error) {
        // Multiple error handler:
        if (error.response.status == 406) {
          const items = [];
          var obj = error.response.data.messages;
          for (var [key, value] of Object.entries(obj)) {
            const item = `${key}: ${value}`;
            items.push(item);
          }
          this.handleError.items = items;
        }
      } finally {
        this.loading = false;
      }
    },
    // Close Dialog
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
    // Tratando password
    // handleType() {
    //   this.fieldTypes.password = "password";
    // },
  },
};
</script>
